import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/Main";
import Companies from "../Pages/Companies/Companies";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import Home from "../Pages/Home/Home";

export const routes = createBrowserRouter([
    {
        path:'/',
        element:<Main></Main>,
        errorElement:<ErrorPage></ErrorPage>,
        children:[
            {
                path:'/',
                element:<Home></Home>
            },
            {
                path:'/company',
                element:<Companies></Companies>
            }
        ]
    },
])